module.exports = __webpack_public_path__ + "img/dedicated-entry.9afcbeb3.svg";